import { faClipboard, faLocationDot } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { toast } from 'react-toastify'
import { Card, CardBody } from 'reactstrap'
import { getCareerJobs, setAllJobProps } from 'store/Recruitment/actions'
import { SET_JOB_TRACKING_ID } from 'store/Recruitment/types'
import ApplyForm from '../JobDetails/ApplyForm'
import { SkillLabel } from '../JobDetails/Details'

function ApplyJob() {
  const location = useLocation()

  const dispatch = useDispatch()
  const {
    careerJobs,
    jobProps,
    jobTrackingId,
    errorMessage,
    creatingApplication,
  } = useSelector((store) => store.recruitment)

  useEffect(() => {
    dispatch(getCareerJobs(location?.search?.split('=')?.at(1)))
  }, [dispatch, location?.search])

  useEffect(() => {
    dispatch(setAllJobProps(careerJobs))
  }, [careerJobs, dispatch])

  useEffect(() => {
    return () => {
      dispatch({ type: SET_JOB_TRACKING_ID, payload: null })
    }
  }, [dispatch])

  console.log(creatingApplication, 'leart40')

  return (
    <Card>
      <CardBody>
        <div
          className='text-center mx-auto d-flex flex-column'
          style={{ gap: '1rem' }}
        >
          <h1>{careerJobs?.title}</h1>
          <div className='d-flex mx-auto' style={{ width: 'fit-content' }}>
            {careerJobs?.skills?.map((skill) => (
              <SkillLabel key={skill?.id} skill={skill} />
            ))}
          </div>
          <span>
            <FontAwesomeIcon icon={faLocationDot} /> {careerJobs?.location}
          </span>
        </div>
        <h2 className='mt-4 mb-3'>Apply for this job</h2>

        <ApplyForm ownApply={true} />

        {errorMessage && (
          <div className='alert alert-danger' role='alert'>
            {errorMessage}
          </div>
        )}
      </CardBody>

      <div className='mb-4 mt--3 mx-auto'>
        <SubmitModalButton
          form='application'
          text={
            creatingApplication
              ? 'Submitting application...'
              : 'Submit your application'
          }
          loading={creatingApplication}
        />
      </div>

      <Card
        role='button'
        onClick={() => {
          navigator.clipboard.writeText(jobTrackingId)
          toast.success(`Tracking id has been copied to clipboard`, {
            position: toast.POSITION.TOP_CENTER,
            className: 'general-settings-toast',
            autoClose: 2500,
          })
        }}
        className='mx-auto'
        style={{
          backgroundColor: 'rgb(226, 247, 217)',
          color: 'rgb(67, 130, 40)',
          width: 'fit-content',
        }}
      >
        {jobTrackingId && (
          <CardBody className='py-3'>
            Job application successfully submitted. your tracking id is:
            <span className='text-dark font-weight-bold'>
              {' '}
              {jobTrackingId}
              <FontAwesomeIcon icon={faClipboard} className='ml-2' size='lg' />
            </span>
          </CardBody>
        )}
      </Card>
    </Card>
  )
}

export default ApplyJob
